import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import useSecurity from '../shared/hooks/useSecurity'

import { MULTICALCULO_ROLE_ID, hasAnyRegionalRole } from '../shared/constants'

const PUBLIC_PATHS = ['/', '/error']
const MULTICALCULO_PREFIX = '/multicalculo'

const PrivateWrapper = () => {
  const {
    getUser,
    getUserRoles,
  } = useSecurity()
  const currentUser = getUser()
  const location = useLocation()

  if (!currentUser?.id) {
    return <Navigate to="/login" />
  }

  const isPublicPath = PUBLIC_PATHS
    .some((path) => location.pathname === path || location.pathname.startsWith(`${path}/`))

  if (isPublicPath) {
    return <Outlet />
  }

  const roles = getUserRoles()
  const isMulticalculo = roles?.some(({ id }) => id === MULTICALCULO_ROLE_ID) ?? false
  const isRegional = hasAnyRegionalRole(roles)

  const requiresMulticalculo = location.pathname.startsWith(MULTICALCULO_PREFIX)
  const canAccess = requiresMulticalculo ? isMulticalculo : isRegional

  if (!canAccess) {
    return (
      <Navigate
        to={isMulticalculo ? '/multicalculo/solicitacoes' : '/solicitacoes'}
        replace
      />
    )
  }

  return <Outlet />
}

export default PrivateWrapper
